(function () {
  // Size guide modal
  const triggers = document.querySelectorAll('[data-bv-size-trigger]');
  const modal = document.querySelector('[data-bv-size-modal]');
  if (modal) {
    triggers.forEach((t) =>
      t.addEventListener('click', (e) => {
        e.preventDefault();
        modal.setAttribute('data-open', 'true');
        document.body.style.overflow = 'hidden';
      }),
    );
    modal.addEventListener('click', (e) => {
      if (e.target === modal || e.target.hasAttribute('data-bv-modal-close')) {
        modal.setAttribute('data-open', 'false');
        document.body.style.overflow = '';
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.getAttribute('data-open') === 'true') {
        modal.setAttribute('data-open', 'false');
        document.body.style.overflow = '';
      }
    });
  }

  // FAQ accordion
  document.querySelectorAll('.bv-faq__q').forEach((q) => {
    q.addEventListener('click', () => {
      const item = q.closest('.bv-faq__item');
      const open = item.getAttribute('data-open') === 'true';
      item.setAttribute('data-open', open ? 'false' : 'true');
    });
  });

  // PDP accordion (product details / about blocks)
  document.querySelectorAll('.bv-pdp-acc__q').forEach((q) => {
    q.addEventListener('click', () => {
      const item = q.closest('.bv-pdp-acc__item');
      const open = item.getAttribute('data-open') === 'true';
      item.setAttribute('data-open', open ? 'false' : 'true');
      q.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  });

  // Sticky ATC — show when the real ATC scrolls out of view
  const stickyAtc = document.querySelector('[data-bv-sticky-atc]');
  const mainAtc = document.querySelector('product-form-component form button[type="submit"], .product-form__submit, form[action*="/cart/add"] button[type="submit"]');
  if (stickyAtc && mainAtc) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          stickyAtc.setAttribute('data-visible', entry.isIntersecting ? 'false' : 'true');
        });
      },
      { threshold: 0.05 },
    );
    observer.observe(mainAtc);

    // Wire the sticky CTA to click the real form's submit
    const stickyCta = stickyAtc.querySelector('[data-bv-sticky-cta]');
    if (stickyCta) {
      stickyCta.addEventListener('click', (e) => {
        e.preventDefault();
        mainAtc.click();
      });
    }
  }
})();
